import React from 'react';
import classNames from "classnames";

import {DocumentContextMenuItem, DocumentContextMenuItemProps} from "./DocumentContextMenuItem";


import './DocumentContextMenuComponent.css';


export type ContextItemParams = Omit<DocumentContextMenuItemProps, 'handleClose'> | {
    condition?: boolean;
    content: React.ReactNode;
};

export interface ContextMenuProps {
    handleClose: () => void;
    itemGroups: ContextItemParams[][];
    isDark?: boolean;
    isWide?: boolean;
}

export const DocumentContextMenuComponent = (
    {
        handleClose,
        itemGroups,
    }: ContextMenuProps
) => {
    let flattenItems: ContextItemParams[] = [];
    for (const groupedItems of itemGroups) {
        const filteredGroup = groupedItems.filter(
            (documentContextMenuItem => documentContextMenuItem.condition === undefined || documentContextMenuItem.condition)
        );
        if (filteredGroup.length > 0) {
            flattenItems = flattenItems.concat(...filteredGroup);
            flattenItems.push({
                content: (<div className={'DocumentContextMenuComponent-divider'}/>)
            })
        }
    }
    flattenItems.pop();

    return (
        <div className={
            classNames({
                'DocumentContextMenuComponent body-large': true,
            })
        }>
            {
                flattenItems.map((contextMenuItem, index) => {
                    if ('content' in contextMenuItem) {
                        return <div key={index} style={{width: '100%'}}>{contextMenuItem.content}</div>
                    } else {
                        return (
                            <DocumentContextMenuItem
                                key={index}
                                text={contextMenuItem.text}
                                onClick={contextMenuItem.onClick}
                                handleClose={handleClose}
                                Icon={contextMenuItem.Icon}
                            />
                        )
                    }
                })
            }
        </div>
    )
}
